exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "span.tag.is-dark.is-bottom[data-v-268d4794]{margin-top:15px}a.button.is-black.is-rounded.is-vcentered[data-v-268d4794]{margin-top:32px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-268d4794","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/cotizaciones_Componentes/componentes/FormDesglose.vue
// module id = 3089
// module chunks = 0